<template lang="pug">
  v-dialog(v-model="showRemoveDialog" max-width="500" persistent)
    v-card.d-flex.flex-column(flat)
      v-form(v-model="isFormValid" @submit.prevent="onSubmitButtonClick" ref="form" :disabled="inProgress" lazy-validation)
        v-card-title.headline {{ $t('removeCreditValue') }}
        v-card-text.pb-1.flex-shrink-0.flex-grow-1.card-body
            v-row
              v-col(cols="12")
                v-text-field(outlined v-model="amount" :label="$t('amount')" :rules="amountRules")
                v-text-field(outlined v-model="description" :label="$t('description')" :hint="hint" persistent-hint)
        v-divider
        v-card-actions
          v-spacer
          v-btn(color="primary" text @click="onCancelButtonClick" :disabled="inProgress") {{ $t('optOutDialog.cancelButtonLabel') }}
          v-btn(color="primary" type="submit" :loading="inProgress" :disabled="!isFormValid") {{$t('optOutDialog.submitCreditButtonLabel') }}

</template>

<script lang="ts">

import {Component, Prop, Ref} from "vue-property-decorator";
import Vue from 'vue';
import i18n from "@/i18n";
import type {BoarderResponse} from "@/types/service-response";
import {CreditDetailsPayload} from "@/types/payload";
import {Action} from "vuex-class";
import {INSERT_CREDIT_OPERATION} from "@/store/action-types";
import CreditDetails from "@/model/CreditDetails";


@Component({})

export default class RemoveCreditDialog extends Vue {
  @Ref('form') readonly form!: Vue & { validate(): boolean }
  @Prop({ type: Boolean, default: false }) readonly showRemoveDialog!: boolean
  @Prop({type: Object, required: false}) readonly boarder!: BoarderResponse
  @Action(INSERT_CREDIT_OPERATION) creditDetailOperation!: ({ (payload: CreditDetailsPayload): Promise<CreditDetails> })


  private amount: any = ''
  private description: string = ''
  private hint: string = i18n.t('descriptionText').toString()
  private amountRules: Array<(v: string) => string | boolean> = [
    (v: string) => !!v || i18n.t('validation.valueIsRequired').toString(),
    (v: string) => parseFloat(v) > 0 || i18n.t('validation.valueIsRequired').toString(),
    (v: string) => {
      const pattern = /^\d+(?:\.\d{1,2})?$/
      return pattern.test(v) || i18n.t('ValidationText').toString()
    }
  ]
  private isFormValid: boolean = true
  private inProgress: boolean = false

  onSubmitButtonClick (): void {
    if (this.form.validate()) {
      const payload: any = {
        personId: this.boarder.person.id,
        kind: 'debit',
        amount: this.amount * 1,
        description: this.description
      }
      this.creditDetail(payload)
    }
  }

  onCancelButtonClick (): void {
    this.$emit('close')
  }

  async creditDetail(payload:CreditDetailsPayload): Promise<void> {
    try {
      this.inProgress = true
      await this.creditDetailOperation(payload)
      this.$emit('saved')
    } catch (e) {
      this.$emit('error')
    } finally {
      this.inProgress = false
    }
  }




}

</script>

<style lang="stylus" scoped>

</style>
